import { IconBadgeCertified, IconBadgeValidated, IconBadgeVerified } from 'src/components/Svg/Images';
import { cn } from 'src/lib/utils';

import { useAppCard, type CertificateBadge } from '../model';

const TYPE_ICON: Record<CertificateBadge['type'], typeof IconBadgeCertified> = {
  verified: IconBadgeVerified,
  validated: IconBadgeValidated,
  certified: IconBadgeCertified,
};

const CertificateBadges = () => {
  const { data } = useAppCard();

  return (
    <div className="flex items-center gap-2">
      {data.certificateBadges.map((badge) => {
        const Icon = TYPE_ICON[badge.type];

        return (
          <div
            key={badge.type}
            className={cn('flex items-center gap-1 text-xs font-semibold', badge.count === 0 && 'opacity-40')}
          >
            <Icon className="size-5.5 shrink-0" data-testid={`certificate-badge-icon-${badge.type}`} />
            {badge.count}
          </div>
        );
      })}
    </div>
  );
};

export { CertificateBadges };
